module.exports = __webpack_public_path__ + "img/paypal.12107368.svg";